if (!customElements.get('feature-blog')) {
    customElements.define(
        'feature-blog',
        class FeatureBlog extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.limit = this.dataset.limit;
                this.init();
            }

            init() {
                const tabs = this.listTabs;
                if (!tabs.length) return;

                tabs.forEach(tab => {
                    tab.addEventListener('click', this.handleTabClick.bind(this, tab));
                });
            }

            get listTabs() {
                return this.querySelectorAll('.blog-navigation__list a');
            }

            async handleTabClick(tab, event) {
                event.preventDefault();

                const sectionParent = tab.closest('.js-section-id');
                if (!sectionParent) return;

                const sectionId = sectionParent.dataset.sectionId;
                const urlObj = new URL(tab.href, window.location.origin);
                urlObj.searchParams.set('section_id', sectionId);
                urlObj.searchParams.set('limit', this.limit);
                console.log(urlObj)
                // UI state: loading
                this.updateActiveTab(tab, 'loading');

                try {
                    const html = await this.fetchData(urlObj.toString());
                    if (!html) throw new Error('No content returned');

                    this.replaceSectionContent(sectionParent, html);
                    this.updateActiveTab(tab, 'active');
                } catch (error) {
                    console.error('Fetch failed:', error);
                    this.updateActiveTab(null);
                }
            }

            updateActiveTab(activeTab, state = 'none') {
                this.listTabs.forEach(tab => {
                    tab.classList.remove('link--active', 'link--loading');
                });

                if (activeTab) {
                    if (state === 'loading') {
                        activeTab.classList.add('link--loading');
                    } else if (state === 'active') {
                        activeTab.classList.add('link--active');
                    }
                }
            }

            replaceSectionContent(sectionElement, html) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;

                const newContent = tempDiv.querySelector('.js-main-content');
                const currentContent = sectionElement.querySelector('.js-main-content');

                if (newContent && currentContent) {
                    currentContent.replaceWith(newContent);
                    this.reInitTabs();
                }
            }

            reInitTabs() {
                this._listTabs = this.querySelectorAll('.blog-navigation__list a');
                this._listTabs.forEach(tab => {
                    tab.addEventListener('click', (e) => this.handleTabClick(tab, e));
                });
            }


            async fetchData(url) {
                try {
                    const response = await fetch(url);
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    return await response.text();
                } catch (error) {
                    console.error('Fetch error:', error);
                    return null;
                }
            }
        }
    );
}
